import { MetadataKey, useGetLoggedInUser } from '@revelio/auth';

import { getMetadataValue } from '../../../../../adminRewrite/utils/helpers';

export const useSourceWhaleApiKey = () => {
  const { loggedInUser } = useGetLoggedInUser();
  const apiKey =
    getMetadataValue(loggedInUser?.metadata, MetadataKey.SourcewhaleKey) ||
    null;

  return {
    isEnabled: apiKey !== null,
    apiKey,
  };
};
